import {h, render, Component} from 'preact';
import copy from 'copy-to-clipboard';
import CommonBlock from './../commonBlock';
import Utils from '../../../utils';
import {Context} from '../../context';
import CiblerAPI from '../../ciblerApi';
import './index.scss'

export default class Form extends CommonBlock {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      formData: [],
      userData: {},
      hidden: true,
      noImage: false,
      copied: false,
    };
  }

  componentDidMount() {
    const content = this.renderContent();

    if (content) {
      this.setState({
        content,
      }, this.bindButtons);
    }

    setTimeout(() => this.setState({hidden: false}), 500);
    if (Utils.getCampaignData(this.props.customJS)) {
      try {
        eval(Utils.getCampaignData(this.props.customJS));
      } catch (e) {
        console.log('CustomJS error: ', {e});
      }
    }
  }

  localHandleAccept = (e) => {
    const {campaignId} = this.props;

    if (Context[campaignId].successRateId) window.WIO.track('successClick', Context[campaignId].successRateId);

    copy(this.state.giftCode);
    this.setState({copied: true});
  }

  render() {
    const imageSrc = Utils.getCampaignData(this.props.backgroundImg)
      ? `${Context.clientUrl}campaigns/assets/${this.props.campaignId}/${Context.device}${Utils.getCampaignData(this.props.backgroundImg)}`
      : null;

    const modalStyle = {
      transition: 'opacity linear 500ms',
      display: this.state.hidden ? 'none' : '',
    };
    if (Utils.getCampaignData(this.props.modalColor, '')) modalStyle.backgroundColor = Utils.getCampaignData(this.props.modalColor, '');

    const {
      hidden, noImage, showGift, content, copied,
    } = this.state;
    return (
      <div
        id="wio_popupv3"
        style={hidden ? {bottom: '-100%', opacity: 0} : {}}
      >
        <style>{`
          #wio_popupv3 .block {
            color: ${Utils.getCampaignData(this.props.textColor, '#000')};
            background-color: ${Utils.getCampaignData(this.props.backgroundColor, '#fff')};
            font-family: ${Utils.getCampaignData(this.props.fontFamily, 'inherit')};
            border-radius: ${Utils.getCampaignData(this.props.borderRadius, '0')};
          }
          #wio_popupv3 .discoverButton {
            background: ${Utils.getCampaignData(this.props.acceptButtonColor, '#C5CDCD')};
            color: ${Utils.getCampaignData(this.props.acceptButtonFontColor, '#FFFFFF')};
          }
          #wio_popupv3 .discoverButton.copied {
            background: ${Utils.getCampaignData(this.props.copiedButtonColor, '#F0FFF5')};
            color: ${Utils.getCampaignData(this.props.copiedButtonFontColor, '#39BB66')};
            border: solid 1px ${Utils.getCampaignData(this.props.copiedButtonFontColor, '#39BB66')};
          }
        `}</style>
        <div
          className="block"
        >
          {!noImage &&
          <img className="image" src={imageSrc}
               onError={() => this.setState({noImage: true})}
          />
          }
          <div className="form">
            <div
              id="wioContent"
              dangerouslySetInnerHTML={{__html: content}}
            />
            {!showGift ?
              <button
                className="discoverButton"
                dangerouslySetInnerHTML={{
                  __html: Utils.getCampaignData(this.props.acceptButtonText, "J'en profite")
                }}
                onClick={this.handleDiscover}
              />
              :
              <button
                className={`discoverButton ${copied ? 'copied' : ''}`}
                onClick={e => this.handleAccept(e, this.localHandleAccept)}
              >
                {this.buttonType.includes('copy') && !copied &&
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="19.743" viewBox="0 0 17 19.743">
                  <g id="copy" transform="translate(-6.707 -2.086)">
                    <path id="Tracé_43" data-name="Tracé 43"
                          d="M15.18,13.5h7.559a1.836,1.836,0,0,1,1.68,1.96v8.819a1.836,1.836,0,0,1-1.68,1.96H15.18a1.836,1.836,0,0,1-1.68-1.96V15.46A1.836,1.836,0,0,1,15.18,13.5Z"
                          transform="translate(-1.212 -4.91)" fill="none" stroke="#fff" strokeLinecap="round"
                          strokeLinejoin="round" strokeWidth="1"/>
                    <path id="Tracé_44" data-name="Tracé 44"
                          d="M5.52,15.738H4.68A1.836,1.836,0,0,1,3,13.779V4.96A1.836,1.836,0,0,1,4.68,3h7.559a1.836,1.836,0,0,1,1.68,1.96v.98"
                          transform="translate(4.207 -0.414)" fill="none" stroke="#fff" strokeLinecap="round"
                          strokeLinejoin="round" strokeWidth="1"/>
                  </g>
                </svg>
                }
                {copied && <svg xmlns="http://www.w3.org/2000/svg" width="21" height="15" viewBox="0 0 21 15">
                  <path id="check" d="M11.789,20.219,6.81,15.555l-1.7,1.577,6.674,6.253L26.115,9.962,24.432,8.385Z" transform="translate(-5.115 -8.385)" fill="#39bb66"/>
                </svg>
                }
                <span
                  dangerouslySetInnerHTML={{
                    __html: !copied
                      ? Utils.getCampaignData(this.props.copyButtonText, "Copier le code")
                      : Utils.getCampaignData(this.props.copiedButtonText, "Code copié")
                  }}
                />
              </button>
            }
            <button
              className="closeButton"
              dangerouslySetInnerHTML={{
                __html: !(copied && this.exitUrl)
                  ? Utils.getCampaignData(this.props.closeButtonText, "Non merci")
                  : Utils.getCampaignData(this.props.exitButtonText, "Voir les ventes")
              }}
              onClick={!(copied && this.exitUrl)
                ? this.closeBlock
                : () => window.location.href = this.exitUrl
              }
            />
            <button
              id="wioBlockExit"
              style={this.getExitStyle()}
              onClick={this.closeBlock}
            >
              X
            </button>
          </div>
        </div>
        <div id="WioModal" className="WioModal" style={modalStyle} onClick={this.closeBlock}/>
      </div>
    );
  }
}
